<template>
  <div class="modal fade" id="shippingConfigModal" tabindex="-1" role="dialog" style="display: none;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" id="close" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"><i class="fa fa-exchange mr-5"></i>{{ 'countryCarrierConfig' | translate }}</h4>
        </div>
        <div class="modal-body">
          <template v-for="alert in alerts">
            <b-alert :show="alert.dismiss" dismissible :variant="alert.type">
              <h4>
                <i v-if="alert.type == 'success' || alert.type == 'warning' "class="icon fa fa-check"></i>
                <i class="icon fa fa-ban" v-else></i>
                {{'alert_'+alert.type | translate}}!</h4>
              <template v-if="alert.type === 'danger' && alert.message.message === undefined">
                  <span v-for="msg, key in alert.message">
                    {{ msg[0] | translate }}<br>
                  </span>
              </template>
              <template v-else-if="alert.type === 'danger' && alert.message.message !== undefined">
                {{ alert.message.message | translate }}
              </template>
              <template v-else>
                {{alert.message}}
              </template>
            </b-alert>
          </template>
          <div class="row">
            <div class="col-xs-6 mb-10">
              <div class="input-group">
                <label for="carrier">{{'carrier' | translate}}</label>
                <input type="text" class="form-control" id="carrier"
                       :placeholder="'carrier' | translate"
                       v-model="modalShippingConfig.carrier">
              </div>
            </div>
            <div class="col-xs-6 mb-10">
              <div class="input-group col-xs-12">
                <label for="direction">{{'direction' | translate}}</label>
                <select v-model="modalShippingConfig.direction" class="form-control" >
                  <option value="shipping">Versand</option>
                  <option value="return">Retoure</option>
                </select>
              </div>
            </div>
            <div class="col-xs-12 mb-10">
              <div class="input-group col-xs-12">
                <label for="carrier_service_method">{{'carrier_service_method' | translate}}</label>
                <input type="text" class="form-control" id="carrier_service_method"
                       :placeholder="'carrier_service_method' | translate"
                       v-model="modalShippingConfig.carrier_service_method">
              </div>
            </div>
            <div class="col-xs-7 mb-10">
              <span class="mr-15">{{'is_preferred_carrier_mid' | translate}}</span>
            </div>
            <div class="col-xs-5 mb-10">
              <div class="btn-group pb-10" data-toggle="btn-toggle">
                <button type="button" @click="modalShippingConfig.is_preferred_carrier_mid=1" :class="['btn btn-success', modalShippingConfig.is_preferred_carrier_mid==1 ? 'active' : '']"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</button>
                <button type="button" @click="modalShippingConfig.is_preferred_carrier_mid=0" :class="['btn btn-danger', modalShippingConfig.is_preferred_carrier_mid==0 ? 'active' : '']"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
              </div>
            </div>
            <div class="col-xs-7 mb-10">
              <span class="mr-15">{{'is_preferred_carrier_max' | translate}}</span>
            </div>
            <div class="col-xs-5 mb-10">
              <div class="btn-group pb-10" data-toggle="btn-toggle">
                <button type="button" @click="modalShippingConfig.is_preferred_carrier_max=1" :class="['btn btn-success', modalShippingConfig.is_preferred_carrier_max==1 ? 'active' : '']"><i class="fa fa-check mr-5"></i>{{'is_active' | translate}}</button>
                <button type="button" @click="modalShippingConfig.is_preferred_carrier_max=0" :class="['btn btn-danger', modalShippingConfig.is_preferred_carrier_max==0 ? 'active' : '']"><i class="fa fa-ban mr-5"></i>{{'inactive' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="confirmEdit" :disabled="errors.any()" class="btn btn-app btn-success"
                  @click="send()"><span class="fa fa-save "></span>{{'save' | translate}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        props: [
            'modalShippingConfig',
            'isNew'
        ],
        data() {
            return {
                alerts: [],
                salesChannels: {},
                countryCarrierId: 0,
            }
        },
        methods: {
            send() {
                if (!this.isNew) {
                    API.put(`accounting/companies/${this.$route.params.id}/shipping/config/${this.modalShippingConfig.id}`, this.modalShippingConfig)
                        .then($res => {
                          this.alerts.push({dismiss: 4, type: 'success', message: 'success', icon: 'icon fa fa-check', show: true})
                        })
                        .catch(error => {
                          this.alerts.push({dismiss: 4, type: 'danger', message: error.response.data, icon: 'icon fa fa-ban', show: true})
                          this.$emit('newConfigCreated')
                        })
                } else {
                    API.post(`accounting/companies/${this.$route.params.id}/shipping/config`, this.modalShippingConfig)
                        .then(res => {
                          this.alerts.push({dismiss: 4, type: 'success', message: 'success', icon: 'icon fa fa-check', show: true})
                            this.$emit('newConfigCreated')
                        })
                        .catch(error => {
                          this.alerts.push({dismiss: 4, type: 'danger', message: error.response.data, icon: 'icon fa fa-ban', show: true})
                        })
                }
            },
        },
        mounted() {
            API.get('countryCarriers/salesChannels').then(res => {
                this.salesChannels = res.data;
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/tools/Modals/ShippingConfigModal.vue